import React, { FunctionComponent } from 'react';

import { useUnit } from 'effector-react/ssr';

import { useRouter } from 'next/router';

import { $dialogs, setIsOpenFeedbackSuccess } from '@stores/dialogs';

import { makeCatalogRoute } from '@utils/route';
import { applyTypograf } from '@utils/typograf';

import { Button } from '@components/common/Button/Button';
import { Dialog } from '@components/common/Dialog/Dialog';

import styles from './FeedBackSuccessDialog.module.scss';

export const FeedBackSuccessDialog: FunctionComponent = () => {
    const [{ isOpenFeedbackSuccess }, setIsOpenFeedbackSuccessFn] = useUnit([
        $dialogs,
        setIsOpenFeedbackSuccess,
    ]);

    const router = useRouter();

    const redirectToCatalog = () => {
        router.push(makeCatalogRoute());
        setIsOpenFeedbackSuccessFn(false);
    };

    return (
        <Dialog
            isOpen={isOpenFeedbackSuccess}
            setOpen={setIsOpenFeedbackSuccessFn}
            title="Мы получили ваш вопрос"
            classes={{ content: styles.dialogContent }}
        >
            <p className={styles.description}>
                {applyTypograf('Свяжемся с вами в ближайшее время.')}
                <br />
                {applyTypograf('А пока загляните в каталог: там много вкусного!')}
            </p>
            <Button
                variant="green"
                isFullWith
                className={styles.button}
                onClick={redirectToCatalog}
            >
                В каталог
            </Button>
        </Dialog>
    );
};
